/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDto } from './OrderDto';
import {
    OrderDtoFromJSON,
    OrderDtoFromJSONTyped,
    OrderDtoToJSON,
} from './OrderDto';

/**
 * 
 * @export
 * @interface OrdersResponseDto
 */
export interface OrdersResponseDto {
    /**
     * 
     * @type {Array<OrderDto>}
     * @memberof OrdersResponseDto
     */
    data: Array<OrderDto>;
    /**
     * 
     * @type {number}
     * @memberof OrdersResponseDto
     */
    queryCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersResponseDto
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the OrdersResponseDto interface.
 */
export function instanceOfOrdersResponseDto(value: object): value is OrdersResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function OrdersResponseDtoFromJSON(json: any): OrdersResponseDto {
    return OrdersResponseDtoFromJSONTyped(json, false);
}

export function OrdersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OrderDtoFromJSON)),
        'queryCount': json['queryCount'] == null ? undefined : json['queryCount'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function OrdersResponseDtoToJSON(value?: OrdersResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(OrderDtoToJSON)),
        'queryCount': value['queryCount'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}

